import React from 'react';
import { MessageCircle } from 'lucide-react';
import { openWhatsApp } from '../utils/whatsapp';
export function FloatingWhatsApp() {
  const handleWhatsApp = () => {
    openWhatsApp();
  };
  return <button onClick={handleWhatsApp} className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 flex items-center justify-center group" aria-label="Contactar por WhatsApp" data-id="element-137">
      <MessageCircle size={32} data-id="element-138" />
      {/* Tooltip */}
      <span className="absolute right-full mr-4 bg-white text-charcoal px-4 py-2 rounded-lg shadow-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none" data-id="element-139">
        ¡Consultá disponibilidad!
      </span>
    </button>;
}